import { RemoteData } from 'app/infrastructure/remote-data';

const endpoint = {
  userDrafts: 'case/draft/user/current'
};

export const api = {
  getDraftsCount: async (): Promise<number> => {
    const response: any = await new RemoteData(endpoint.userDrafts).resource<any[]>().all();
    return response.data.length;
  }
};
